import Model from './model';

export default class TechnologyCategory extends Model {
  static NAME = 'technology_category';
  static COLLECTION_NAME = "technology_categories";
  static URL = '/api/v2/technology_categories';

  static SUGGESTIONS = [
    '.NET',
    'ABAP',
    'AI',
    'Android',
    'Angular',
    'C/C++',
    'iOS',
    'Java',
    'Kubernetes',
    'Python',
    'React',
    'RPA',
    'Ruby',
    'Spring',
  ]
}